import NavigationBar from "./view"

export default NavigationBar